import React from 'react';
import { motion } from 'framer-motion';
import { InstagramIcon } from 'lucide-react';
function TikTokIcon({
  className
}: {
  className?: string;
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={className} data-id="element-321">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 0 0-.79-.05A6.34 6.34 0 0 0 3.15 15a6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.71a8.21 8.21 0 0 0 4.76 1.52v-3.4a4.85 4.85 0 0 1-1-.14z" data-id="element-322" />
    </svg>;
}
export function SocialSection() {
  return <section className="py-8 md:py-24 bg-white relative" data-id="element-323">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-324">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-325">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-jet mb-4" data-id="element-326">
            Follow Us on Social Media
          </h2>
          <div className="h-1 w-24 bg-burgundy mx-auto rounded-full mb-6" data-id="element-327"></div>
          <p className="text-jet/70 text-lg md:text-xl max-w-2xl mx-auto" data-id="element-328">
            See our latest braiding transformations and behind-the-scenes
            content
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-329">
          {/* Instagram Card */}
          <motion.a href="https://www.instagram.com/benishairbraiding/" target="_blank" rel="noopener noreferrer" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="group relative overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 flex flex-col items-center text-center p-12 bg-gradient-to-br from-[#833AB4] via-[#E1306C] to-[#F77737]" data-id="element-330">
            <div className="absolute inset-0 bg-black/10 group-hover:bg-transparent transition-colors duration-500" data-id="element-331"></div>

            <div className="relative z-10 flex flex-col items-center" data-id="element-332">
              <div className="w-20 h-20 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center mb-6 border border-white/30 group-hover:scale-110 transition-transform duration-500" data-id="element-333">
                <InstagramIcon className="w-10 h-10 text-white" data-id="element-334" />
              </div>

              <h3 className="text-3xl font-heading font-bold text-white mb-2" data-id="element-335">
                Instagram
              </h3>
              <p className="text-white/90 text-lg mb-8 font-medium" data-id="element-336">
                See our portfolio
              </p>

              <span className="inline-flex items-center justify-center px-8 py-4 bg-white text-[#E1306C] rounded-full font-bold uppercase tracking-wider text-sm transition-transform group-hover:scale-105 shadow-lg" data-id="element-337">
                Follow @benishairbraiding
              </span>
            </div>
          </motion.a>

          {/* TikTok Card */}
          <motion.a href="https://www.tiktok.com/@benisbraids" target="_blank" rel="noopener noreferrer" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="group relative overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 flex flex-col items-center text-center p-12 bg-gradient-to-br from-jet to-[#252525]" data-id="element-338">
            <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors duration-500" data-id="element-339"></div>

            <div className="relative z-10 flex flex-col items-center" data-id="element-340">
              <div className="w-20 h-20 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center mb-6 border border-white/20 group-hover:scale-110 transition-transform duration-500" data-id="element-341">
                <TikTokIcon className="w-10 h-10 text-white" data-id="element-342" />
              </div>

              <h3 className="text-3xl font-heading font-bold text-white mb-2" data-id="element-343">
                TikTok
              </h3>
              <p className="text-white/90 text-lg mb-8 font-medium" data-id="element-344">
                Watch our latest styles
              </p>

              <span className="inline-flex items-center justify-center px-8 py-4 bg-white text-jet rounded-full font-bold uppercase tracking-wider text-sm transition-transform group-hover:scale-105 shadow-lg" data-id="element-345">
                Follow @benisbraids
              </span>
            </div>
          </motion.a>
        </div>
      </div>
    </section>;
}